import React from 'react'

export default function Input({ label, icon, id, register, error, placeholder, type }) {
  return (
    <div className="field-container">
      <label htmlFor={id}>
        {icon}
        {label}
      </label>
      <div className="input-field">
        <input type={type} id={id} {...register} placeholder={placeholder} />
        {error && <span>{error}</span>}
      </div>
    </div>
  )
}
